import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const YandexMetrika = () => {
  const location = useLocation();

  useEffect(() => {
    // Отслеживаем переходы между страницами в SPA
    if (window.ym) {
      window.ym(104042927, 'hit', location.pathname + location.search, {
        title: document.title,
        referer: document.referrer
      });
    }
  }, [location]);

  // Функция для отправки событий в Яндекс.Метрику
  const trackEvent = (action, category = 'general', label = '', value = null) => {
    if (window.ym) {
      window.ym(104042927, 'reachGoal', action, {
        category: category,
        label: label,
        value: value
      });
    }
  };

  // Функция для отслеживания просмотров товаров
  const trackProductView = (productId, productName, price = null) => {
    if (window.ym) {
      window.ym(104042927, 'params', {
        product_id: productId,
        product_name: productName,
        product_price: price,
        page_type: 'product'
      });
    }
  };

  // Функция для отслеживания добавления в корзину
  const trackAddToCart = (productId, productName, price = null, quantity = 1) => {
    if (window.ym) {
      window.ym(104042927, 'reachGoal', 'add_to_cart', {
        product_id: productId,
        product_name: productName,
        product_price: price,
        quantity: quantity
      });
    }
  };

  // Функция для отслеживания поиска
  const trackSearch = (query, resultsCount = null) => {
    if (window.ym) {
      window.ym(104042927, 'reachGoal', 'search', {
        search_query: query,
        results_count: resultsCount
      });
    }
  };

  // Функция для отслеживания просмотра категории
  const trackCategoryView = (categoryId, categoryName, productsCount = null) => {
    if (window.ym) {
      window.ym(104042927, 'params', {
        category_id: categoryId,
        category_name: categoryName,
        products_count: productsCount,
        page_type: 'category'
      });
    }
  };

  // Экспортируем функции для использования в других компонентах
  window.trackEvent = trackEvent;
  window.trackProductView = trackProductView;
  window.trackAddToCart = trackAddToCart;
  window.trackSearch = trackSearch;
  window.trackCategoryView = trackCategoryView;

  return null; // Компонент не рендерит ничего
};

export default YandexMetrika;
